const runtimeEnv = window.__ENV__ || {};

export const env = {
  REACT_APP_BACKEND_URL:
    runtimeEnv.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "",
  REACT_APP_NAME: runtimeEnv.REACT_APP_NAME || process.env.REACT_APP_NAME || "",
  REACT_APP_VERSION:
    runtimeEnv.REACT_APP_VERSION || process.env.REACT_APP_VERSION || "",
};
